import { Injectable } from '@angular/core';
import { UserI } from '@interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class ChatTabsUsersService {
  constructor() {}

  public setActivityStatus(user: UserI, status: boolean): UserI {
    switch (status) {
      case true:
        user.activityStatus = 'online';
        break;

      default:
        user.activityStatus = 'offline';
        break;
    }
    return user;
  }
}
